import appConfig from 'app.config'

/**
 * Returns the Location object's URL's origin + callback path.
 * @param {string} callbackPath to callback
 */
export function getReturnUrl(callbackPath: string = '/callback') {
	return window.location.origin + callbackPath
}

/**
 * Returns the Location object's URL's origin + callback path.
 * @param {string} callbackPath to callback
 */
export function getSignicatReturnUrl(
	callbackPath: string = '/signicatcallback'
) {
	return window.location.origin + callbackPath
}

/**
 * Returns the Location object's URL's origin + callback path.
 * @param {string} callbackPath to callback
 */
export function getNorwegianBankIdReturnUrl(
	callbackPath: string = '/norwegianbankidcallback'
) {
	return window.location.origin + callbackPath
}

/**
 * Returns masked version of ssn
 * @param ssn
 * @returns
 */
export function maskSsn(ssn: string) {
	if (appConfig.country === 'se') return ssn.substr(0, ssn.length - 4)
	return ssn
}

export function formatBirthDateWithDashes(birthDateOnlyNumbers: string) {
	const formattedBirthDate =
		birthDateOnlyNumbers.slice(0, 4) +
		'-' +
		birthDateOnlyNumbers.slice(4, 6) +
		'-' +
		birthDateOnlyNumbers.slice(6, 8)
	return formattedBirthDate
}

/**
 * Returns the Location object's URL's origin + callback path.
 * @param {string} callbackPath to callback
 */
export function geteParakstsReturnUrl(
	callbackPath: string = '/eparakstscallback'
) {
	return window.location.origin + callbackPath
}